import { AddProduct } from './ui';

export { AddProduct };
